import { Task } from '../../domain/entities/Task';

export class TaskMapper {
    /**
     * Mapeia dados do banco para entidade de domínio
     * Inclui extração de dados relacionados (opportunities, contacts, profiles)
     */
    static toEntity(data: any): Task {
        const task = new Task(
            data.id,
            data.opportunity_id || null,
            data.title,
            new Date(data.due_date),
            data.is_completed,
            data.description || '',
            data.type || '',
            data.assigned_to,
            new Date(data.created_at)
        );

        // Anexa dados relacionados diretamente na entidade (para uso na camada de apresentação)
        // Esses dados vêm dos JOINs feitos nas queries
        (task as any).opportunity = data.opportunities || null;
        const profile = Array.isArray(data.profiles) ? data.profiles[0] : data.profiles;
        (task as any).assignedToProfile = profile || null;

        return task;
    }

    /**
     * Mapeia entidade de domínio para formato do banco
     */
    static toDatabase(task: Task): any {
        return {
            id: task.id,
            opportunity_id: task.leadId || null,
            title: task.getTitle(),
            due_date: task.getDueDate().toISOString(),
            is_completed: task.getIsCompleted(),
            description: task.getDescription(),
            type: task.getType(),
            assigned_to: task.assignedTo
        };
    }
}
